import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FiAlertTriangle, FiTarget, FiTrendingDown, FiUsers } from "react-icons/fi";

const stats = [
  {
    title: "Total No of Leads",
    value: "6000",
    change: "-4.01%",
    color: "#f97316",
    icon: <FiAlertTriangle />,
    progress: 40,
    trend: "down",
  },
  {
    title: "No of New Leads",
    value: "120",
    change: "+20.01%",
    color: "#0f3d4a",
    icon: <FiTarget />,
    progress: 60,
    trend: "up",
  },
  {
    title: "No of Lost Leads",
    value: "30",
    change: "+55%",
    color: "#ef4444",
    icon: <FiTrendingDown />,
    progress: 50,
    trend: "up",
  },
  {
    title: "No of Total Customers",
    value: "9895",
    change: "+55%",
    color: "#a855f7",
    icon: <FiUsers />,
    progress: 70,
    trend: "up",
  },
];

export default function LeadsStatsCards() {
  return (
    <Row>
      {stats.map((item, i) => (
        <Col xl={3} md={6} key={i} className="mb-3">
          <Card className="sc-card">
            <Card.Body>
              {/* TOP */}
              <div className="sc-top">
                <div
                  className="sc-icon"
                  style={{ background: item.color }}
                >
                  {item.icon}
                </div>

                <div>
                  <p className="sc-title">{item.title}</p>
                  <h4 className="sc-value">{item.value}</h4>
                </div>
              </div>

              {/* PROGRESS */}
              <div className="sc-progress">
                <div
                  className="sc-bar"
                  style={{
                    width: item.progress + "%",
                    background: item.color,
                  }}
                ></div>
              </div>

              {/* BOTTOM */}
              <p
                className={`sc-change ${
                  item.trend === "up" ? "up" : "down"
                }`}
              >
                ~ {item.change} from last week
              </p>
            </Card.Body>

            {/* INLINE CSS */}
            <style>{`
              .sc-card {
                border-radius: 10px;
                border: 1px solid #e5e7eb;
              }

              .sc-top {
                display: flex;
                align-items: center;
                gap: 12px;
                margin-bottom: 12px;
              }

              .sc-icon {
                width: 44px;
                height: 44px;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 18px;
              }

              .sc-title {
                font-size: 14px;
                color: #6b7280;
                margin: 0;
              }

              .sc-value {
                margin: 0;
                font-weight: 600;
              }

              /* PROGRESS BAR */
              .sc-progress {
                height: 6px;
                background: #e5e7eb;
                border-radius: 10px;
                overflow: hidden;
                margin-bottom: 10px;
              }

              .sc-bar {
                height: 100%;
                border-radius: 10px;
              }

              /* CHANGE TEXT */
              .sc-change {
                font-size: 13px;
                margin: 0;
              }

              .sc-change.up {
                color: #16a34a;
              }

              .sc-change.down {
                color: #dc2626;
              }

              /* RESPONSIVE */
              @media (max-width: 1024px) {
                .sc-card {
                  margin-top: 10px;
                }
              }
            `}</style>
          </Card>
        </Col>
      ))}
    </Row>
  );
}